module.exports = __webpack_public_path__ + "img/Icon2.ba46792c.svg";